import styled from "@emotion/styled";

import { ArticleStyles } from "./article-styles";

export const Article = styled.article`
  ${ArticleStyles};
`;
